export const ROWS_PER_PAGE = 100;
export const DATEPICKER_FORMAT = 'dd-MM-yyyy';
export const NO_ORDERS_FOUND_MESSAGE = 'No orders found';

export const ORDERS_TABLE_STATUS = [
  'AWAITING_APPROVAL',
  'APPROVAL_REJECTED',
  'APPROVAL_EXPIRED',
  'APPROVAL_INCOMPATIBLE',
  'AWAITING_SUPPLIER_APPROVAL',
  'APPROVED_BY_SUPPLIER',
  'REJECTED_BY_SUPPLIER',
  'AWAITING_SHIPMENT',
  'RECEIVED',
  'RECEIVED_WITH_DISPUTE',
  'COMPLETED',
  'CANCELLED'
] as const;
